const CaseStudyText = () => {
  return (
  <section className="py-3">
    <div className="container">
      <div className="row">
        <div className="col">
          <h3 className="font-bold text-uppercase text-red">Case Study</h3>
          <p>Cadillac desired a name that would revitalize the Cadillac brand and develop a single identity that would redefine the SUV market.</p>
          <p>Through QualiQuantitative Interviews that specifically included 100 SUV dealers and 100 individuals who had owned an SUV for a minimum of three years, the following eight names were developed and evaluated:
          </p>
        </div>
      </div>
    </div>
  </section>
  );
};

export default CaseStudyText;